<template>
  <ul class="margin-left-xs">
    <li v-for="(item, i) in list" :key="i">
      <slot :item="item" />
    </li>
  </ul>
</template>

<script setup>
defineProps({
  list: {
    type: Array,
    required: true,
  },
});
</script>
